var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"fontSize",attrs:{"padless":"","color":"primary","dark":""}},[_c('v-col',{staticClass:"text-start",attrs:{"cols":"12"}},[_vm._v(" © 2017-"+_vm._s(new Date().getFullYear())+" Global Psytech Sdn. Bhd. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }